import styled from 'styled-components';

import { unitMapping, type Unit } from '#src/lib/style.ts';

const SCOREBOARD_GRADIENT =
  'linear-gradient(to bottom, #FFE5F0, rgb(var(--orb-color, 255, 30, 81)))';

const Frame = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  border-radius: 2px;
  padding: 0 1px;
  font: var(--t-bold) 9px/1 var(--sorare-font);
  font-variant-numeric: tabular-nums;
  letter-spacing: 0.02em;
  white-space: nowrap;
  position: relative;
  &::before {
    content: '';
    position: absolute;
    inset: 0;
    border-radius: inherit;
    padding: 1px;
    background: ${SCOREBOARD_GRADIENT};
    mask:
      linear-gradient(#fff, #fff) content-box,
      linear-gradient(#fff, #fff);
    mask-composite: exclude;
    pointer-events: none;
  }
`;

type Props = {
  size?: Unit;
  homeGoals: number;
  awayGoals: number;
};

export const LobbyScore = ({ size = 1, homeGoals, awayGoals }: Props) => {
  const dimension = unitMapping[size];

  return (
    <Frame style={{ width: dimension, height: `calc(${dimension} * 0.72)` }}>
      <span
        className="text-gradient-color"
        style={
          {
            '--text-gradient-color': SCOREBOARD_GRADIENT,
          } as React.CSSProperties
        }
      >
        {homeGoals}:{awayGoals}
      </span>
    </Frame>
  );
};
